// Dependencies
import styled, { css } from 'styled-components'

// Types
export type AssetStyleProps = {
  size: number
  color: string
  hoverColor?: string
}

export const Container = styled.div<AssetStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    ${({ size }) =>
      css`
        width: ${size}px;
        height: ${size}px;
      `}

    ${({ hoverColor }) =>
      !!hoverColor &&
      css`
        cursor: pointer;

        &:hover {
          > path {
            stroke: ${hoverColor};
          }
        }
      `}

        > path {
      ${({ color }) =>
        css`
          stroke: ${color};
        `}
    }
  }
`
